import {
    FIND_INDICATOR_IDS_REQUEST,
} from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const isIndicatorIdsLoading = (state) =>
    ArrayContains(state.statementTemplate.openRequests, [
        FIND_INDICATOR_IDS_REQUEST,
    ]);